import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { callAPI } from "../../../../../axios";
import { getMasterPermissions } from "../../../../../store/actions/PersmissionActions/PersmissionActions";
import { Grid } from "@mui/material";
import Controls from "../../../../core/Controls/Controls";
import AddPermission from "../AddPermission/AddPermission";
import PermissionBlock from "../PermissionBlock/PermissionBlock";
import "./UserPrivileges.scss";
import { isValidRole } from "../../../../../utils/utils";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import BasicModal from "../../../../core/BaseComponents/Modal";

const UserPrivileges = (props) => {
  const [addPermission, setAddPermission] = useState(false);
  const [error, setError] = useState("");
  const [selectedModule, setSelectedModule] = useState(0);
  const [userList, setUserList] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [roleInfo, setRoleInfo] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [userPrivilegeSuccess, setUserPrivilegeSuccess] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const { roleSel } = props?.location !== undefined ? props?.location : 0;
  const [user, setUser] = useState(roleSel);
  const [flag, setFlag] = useState(false);
  const [selectUserName, setSelectUserName] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  let validPermissionClassName = isValidRole("EDIT_PERMISSIONS")
    ? "cursor-pointer"
    : "actionButtonDisable";
  // alert(userDetails.userName)
  const userNameId = userDetails.userName;

  const populateGridData = (userList) => {
    let rows = [];
    if (userList !== undefined && userList !== "") {
      userList.forEach((u) => {
        rows.push({ ...u, id: u.sid, title: u.name });
      });
    }
    setUserList(rows);
  };

  const getUserList = () => {
    // setLoading(true);
    const apiPath = `user/list`;
    callAPI(apiPath, "GET")
      .then((res) => {
        const temp = res?.map((e) => {
          return { ...e, name: e.userName };
        });
        populateGridData(temp);
      })
      .catch((err) => {
        console.warn(err.message);
      })
      .finally((_) => {
        // setLoading(false);
      });
  };

  const getUserRole = () => {
    // setLoading(true);
    const apiPath = `/user/permission?userSid=${user}`;
    callAPI(apiPath, "GET")
      .then((res) => {
        // console.log("srin",res)
        setRoleInfo(res);
      })
      .catch((err) => {
        console.warn(err.message);
      })
      .finally((_) => {
        // setLoading(false);
      });
  };

  const addPermissionHandler = (args) => {
    const temp = { ...selectedPermissions };
    // temp[args.module] = args;
    if (
      args.selectedPermission &&
      args.selectedPermission.some((x) => x.checked == true)
    ) {
      temp[args.module] = args;
    } else {
      delete temp[args.module];
    }
    setUserInfo({
      ...userInfo,
      tempPermissions: temp,
    });
    setSelectedPermissions(temp);
  };

  const showPermissionModal = () => {
    if (user) {
      setSelectedModule(0);
      setAddPermission(true);
    } else {
      setError("Please Select User Name");
    }
  };

  const updatePermissionHandler = (item) => {
    setSelectedModule(item.module);
    setAddPermission(true);
    setFlag(true);
  };

  const deletePermissionHandler = (item) => {
    const temp = { ...selectedPermissions };
    delete temp[item.module];
    setSelectedPermissions(temp);
  };

  const resetData = () => {
    setUser(0);
    setSelectedPermissions({});
    getUserList();
  };

  const saveData = () => {
    const userSid = user;
    const permissionSids = [];
    Object.keys(selectedPermissions).forEach((moduleId) => {
      selectedPermissions[moduleId].selectedPermission.forEach((per) => {
        if (per.checked) {
          permissionSids.push(per.id);
        }
      });
    });
    if (userSid === 0) {
    } else {
      // setLoading(true);
      const apiPath = `/user/permission`;
      callAPI(apiPath, "PUT", {
        userSid: userSid,
        permissionSids: permissionSids,
      })
        .then((res) => {
          setShowPopup(true);
          setUserPrivilegeSuccess(res.message);
          // resetData();
        })
        .catch((err) => {
          console.warn(err)
        })
        .finally((_) => {
          // setLoading(false);
        });
    }
  };
  useEffect(() => {
    const userInfo = userList?.find((u) => u.sid === user);
    const tempPermissions = {};
    if (userInfo) {
      const savedPermissions = roleInfo.permissions;

      savedPermissions.forEach((sp) => {
        if (tempPermissions[sp.parentPermissionSid] === undefined) {
          tempPermissions[sp.parentPermissionSid] = {};
          tempPermissions[sp.parentPermissionSid].module =
            sp.parentPermissionSid;
          tempPermissions[sp.parentPermissionSid].selectedPermission = [];
        }
        tempPermissions[sp.parentPermissionSid].selectedPermission.push({
          ...sp,
          checked: true,
          title: sp.permission,
        });
      });
    }
    setSelectedPermissions(tempPermissions);
    setUserInfo({
      ...userInfo,
      tempPermissions: tempPermissions,
    });
  }, [roleInfo]);

  useEffect(() => {
    props.getMasterPermissions();
    getUserList();
    if (user) {
      getUserRole();
    }
  }, [user]);

  // useEffect(() => {
  //   getUserRole();
  // }, [user]);

  const closePopupHandler = () => {
    setShowPopup(false);
    setUserPrivilegeSuccess(null);
  };

  return (
    <>
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to="/hms/ConfigurationNewHotel">Dashboard </Link>{" "}
            <span className="arrow-color"> &#62; </span>
          </li>
          <li>User privileges</li>
        </ul>
      </div>
      <div className="sub-header">
        <h1> User Privileges</h1>
      </div>
      <div className="roles-and-permission">
        {/* <Loader show={loading} /> */}

        <div className="d-flex justify-content-between">
          <div className="position-relative">
            <label className="d-block">User Name</label>
            <Controls.Select
              className={"control-select"}
              name={"userrolesandpermissions"}
              value={user}
              items={userList}
              optionDisabledProp={userNameId}
              placeholder="Please Select User Name"
              onChange={(e) => {
                setUser(e.target.value);
                e.target.value !== 0 && setError("");
                setSelectUserName(true);
              }}
              error={error}
            />
            {/* <span className="pe-7s-angle-down rolesdown"></span> */}
            {/* {!selectUserName && <p className="userRolesPlaceholder">Please Select User Name</p>}  */}
          </div>
          <div className="align-self-end">
            <div className={`createuser ${validPermissionClassName}`}>
              <span
                className="cursor-pointer"
                onClick={
                  isValidRole("EDIT_PERMISSIONS") ? showPermissionModal : null
                }
              >
                <AddIcon className="add-icon-style" />
                Add Permission
              </span>
            </div>
          </div>
        </div>
        {user > 0 && (
          <>
            {" "}
            <div className="w-100">
              <PermissionBlock
                items={selectedPermissions}
                updateHandler={updatePermissionHandler}
                deleteHandler={deletePermissionHandler}
                user={user}
                api={getUserRole}
              />
            </div>
            <div className="d-flex justify-content-end mb-0 pop-btns mt-3">
              <button
                onClick={resetData}
                size="small"
                type="submit"
                className="reset-btn me-3"
              >
                Reset
              </button>
              <button
                onClick={isValidRole("EDIT_PERMISSIONS") ? saveData : null}
                size="small"
                type="submit"
                className={`create-btn ${validPermissionClassName}`}
              >
                Update
              </button>
            </div>
          </>
        )}

        <BasicModal
          popupOpen={showPopup}
          bodyMessage={<>
            {userPrivilegeSuccess && (
              <span className="d-block">
                <img src="/Images/approve-qc.png" alt="approve" style={{ width: 60 }} />
                <p className="mt-2">{userPrivilegeSuccess}</p>
              </span>
            )}
          </>
          }
          footer={
            {
              secondaryButton: {
                buttonName: "OK",
                action: closePopupHandler
              }
            }
          }
        />

      </div>
      {addPermission && (
        <AddPermission
          edit={flag}
          open={addPermission}
          closeHandler={() => {
            setAddPermission(false);
            setFlag(false);
          }}
          onClickHandler={addPermissionHandler}
          selectedModule={selectedModule}
          setSelectedModule={setSelectedModule}
          selectedPermissions={selectedPermissions}
          user={user}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  // console.log(state.permissionReducer.permissions)
  return {
    permissions: state.permissionReducer.permissions,
  };
};

const mapDispatcherToProps = (dispatch) => {
  return {
    getMasterPermissions: () => dispatch(getMasterPermissions()),
  };
};

export default connect(mapStateToProps, mapDispatcherToProps)(UserPrivileges);
